import React from 'react';
import { FaPaperPlane, FaPlane, FaRocket } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './pricing.css';

const PricingTable = () => {
  const handleClick = (packageName, price, options) => {
    const message = `🌟 Package Selected 🌟\n\nName: ${packageName}\nPrice: ${price}\n\nOptions:\n${options.join("\n")}\n\nI have selected this package!`;
    window.open(`https://wa.me/+923095921582/?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="pricing-table">
      <div className="pricing-container">
        <h1>Choose Your Plan</h1>
        <div className="pricing-row">
          {/* One Day */}
          <div className="pricing-col">
            <motion.div whileHover={{ scale: 1.1 }} className="pricing-card text-center">
              <div className="pricing-icon">
                <FaPaperPlane />
              </div>
              <div className="pricing-title">
                <h2>One Day</h2>
              </div>
              <div className="pricing-price">
                <h4>45,000/-</h4>
              </div>
              <div className="pricing-options">
                <ul>
                  <li>1 Photographer</li>
                  <li>Indoor Coverage</li>
                  <li>Outdoor Shoot</li>
                  <li>1 Videographer</li>
                  <li>Cinematic Highlights</li>
                  <li>Couple Title Song</li>
                  <li>Unlimited Pictures</li>
                  <li>Raw Data</li>
                  <li>50 Edited Pictures</li>
                  <li>1 Album</li>
                  {/* Add more advanced options here */}
                </ul>
              </div>
              <button className='book-now-btn' onClick={() => handleClick("One Day", "45,000/-", ["1 Photographer", "Indoor Coverage", "Outdoor Shoot", "1 Videographer", "Cinematic Highlights", "Couple Title Song", "Unlimited Pictures", "Raw Data", "50 Edited Pictures", "1 Album"])}>Choose This Plan</button>
            </motion.div>
          </div>
          {/* Two Day */}
          <div className="pricing-col">
            <motion.div whileHover={{ scale: 1.1 }} className="pricing-card text-center">
              <div className="pricing-icon">
                <FaPlane />
              </div>
              <div className="pricing-title">
                <h2>Two Day</h2>
              </div>
              <div className="pricing-price">
                <h4>85,000/-</h4>
              </div>
              <div className="pricing-options">
                <ul>
                  <li>1 Photographer (2 Days)</li>
                  <li>Indoor Coverage</li>
                  <li>Outdoor Shoot</li>
                  <li>1 Videographer (2 Days)</li>
                  <li>Drone Coverage (1 Day)</li>
                  <li>Cinematic Highlights</li>
                  <li>Couple Title Song</li>
                  <li>Unlimited Pictures</li>
                  <li>50 Edited Pictures</li>
                  <li>Raw Data</li>
                  <li>1 Album</li>
                  {/* Add more advanced options here */}
                </ul>
              </div>
              <button className='book-now-btn' onClick={() => handleClick("Two Day", "85,000/-", ["1 Photographer (2 Days)", "Indoor Coverage", "Outdoor Shoot", "1 Videographer (2 Days)", "Drone Coverage (1 Day)", "Cinematic Highlights", "Couple Title Song", "Unlimited Pictures", "50 Edited Pictures", "Raw Data", "1 Album"])}>Choose This Plan</button>
            </motion.div>
          </div>
          {/* Three Day */}
          <div className="pricing-col">
            <motion.div whileHover={{ scale: 1.1 }} className="pricing-card text-center">
              <div className="pricing-icon">
                <FaRocket />
              </div>
              <div className="pricing-title">
                <h2>Three Day</h2>
              </div>
              <div className="pricing-price">
                <h4>135,000/-</h4>
              </div>
              <div className="pricing-options">
                <ul>
                  <li>1 Photographer (3 Days)</li>
                  <li>Indoor Coverage</li>
                  <li>Outdoor Shoot</li>
                  <li>1 Videographer (3 Days)</li>
                  <li>Drone Coverage (2 Days)</li>
                  <li>Cinematic Highlights</li>
                  <li>Couple Title Song</li>
                  <li>Unlimited Pictures</li>
                  <li>50 Edited Pictures</li>
                  <li>Raw Data</li>
                  <li>2 Albums</li>
                  {/* Add more advanced options here */}
                </ul>
              </div>
              <button className='book-now-btn' onClick={() => handleClick("Three Day", "135,000/-", ["1 Photographer (3 Days)", "Indoor Coverage", "Outdoor Shoot", "1 Videographer (3 Days)", "Drone Coverage (2 Days)", "Cinematic Highlights", "Couple Title Song", "Unlimited Pictures", "50 Edited Pictures", "Raw Data", "2 Albums"])}>Choose This Plan</button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingTable;